
export const gumballBaseUrl = process.env.NEXT_PUBLIC_PETA_GUMBALL_DOMAIN
